(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["herdio-pdp-showroom"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-hspdp]').forEach((root) => {
    if (root.dataset.enhanced === 'true') return;
    root.dataset.enhanced = 'true';
    root.classList.add('hspdp-ready');
    const reviewLink = root.querySelector('[data-hspdp-review-link]');
    if (reviewLink) {
      const updateReviewLink = () => {
        reviewLink.hidden = !document.getElementById('judgeme_product_reviews');
      };
      updateReviewLink();
      window.setTimeout(updateReviewLink, 1500);
      window.setTimeout(updateReviewLink, 4000);
    }
    const items = root.querySelectorAll('[data-hspdp-reveal]');
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach((item) => observer.observe(item));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["herdio-system-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('herdio-system-builder')) {
    customElements.define('herdio-system-builder', class extends HTMLElement {
      connectedCallback() {
        this.options = Array.from(this.querySelectorAll('input[data-quantity]'));
        this.options.forEach((input) => input.addEventListener('change', () => this.selectOption(input)));
        this.querySelector('[data-add-selected]')?.addEventListener('click', () => this.addSelected());
      }
      get quantityInput() { return document.querySelector('.shopify-section--main-product input[name="quantity"]'); }
      selectOption(input) {
        const quantity = Number(input.dataset.quantity || 1);
        this.options.forEach((item) => item.closest('.hsb__option')?.classList.toggle('is-selected', item === input));
        if (this.quantityInput) {
          const maximum = this.quantityInput.max ? Number(this.quantityInput.max) : quantity;
          const minimum = this.quantityInput.min ? Number(this.quantityInput.min) : 1;
          this.quantityInput.value = Math.min(Math.max(quantity, minimum), maximum);
          this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.querySelector('[data-setup-summary]').textContent = input.dataset.setupLabel || '';
        this.querySelector('[data-total-summary]').textContent = input.dataset.totalLabel || '';
      }
      addSelected() { document.querySelector('.shopify-section--main-product buy-buttons button[type="submit"]')?.click(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
